import { Skeleton } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { SkeletonTileViewProgramExperience } from '../../../../Common/ProgramExperience';

function SkeletonTileViewExperiences() {
  return (
    <div className="mx-auto flex w-full flex-col px-0 pb-10 pt-0 xl:container sm:pt-10">
      <div className="flex flex-col gap-4 px-6 md:px-16">
        <Skeleton className="w-4/12" size="lg" />
        <Skeleton />
        <Skeleton className="w-8/12" />
      </div>
      <div className="mt-14 grid gap-4 px-6 sm:grid-cols-2 md:px-16 lg:grid-cols-3 xl:grid-cols-4">
        {Array.from({ length: 12 }, (_, index) => (
          <SkeletonTileViewProgramExperience key={index} />
        ))}
      </div>
    </div>
  );
}

export default observer(SkeletonTileViewExperiences);
